import { Module, ActionContext } from "vuex"
import ajax from "@/lib/ajax"
import { SendEmailActivationLinkInput } from "@/asdcom/apiproxy/apiproxy.dto";

interface AccountState {
  
}

class AccountStore implements Module<AccountState, any> {
  namespaced: true
  state: AccountState = {}
  getters = {}
  mutations = {}
  
  actions = {
    
    // moved from "applicant" store.
    
    // async setSecurityQuestions(context: ActionContext<AccountState, any>, payload: any) {
    //   let data = payload.data
    //   // set username from store.
    //   data.userName = context.rootState.session.user.userName
    //   //console.log("setSecurityQuestions:",data)

    //   await ajax.post(`/api/services/app/Account/SetSecurityQuestions`, data)
    //   context.dispatch("asdcom/app/refreshUserProfileFlags", {}, { root: true })
    // },
    // moved from "app" store.
    async registerDispatch(content: ActionContext<AccountState, any>, payload: any) {
      let rep = await ajax.post("/api/services/app/Account/Register", payload.data)
      return rep
    },
    async resetPasswordDispatch(content: ActionContext<AccountState, any>, payload: any) {
      let rep = await ajax.post("/api/services/app/Account/ResetPassword", payload.data)
      return rep
    },
    async activateEmailDispatch(content: ActionContext<AccountState, any>, payload: any) {
      let rep = await ajax.post("/api/services/app/Account/ActivateEmail", payload.data)
      return rep
    },
    async sendEmailActivationLinkDispatch(content: ActionContext<AccountState, any>, payload: any) {
      // console.log('content',content)
      let rep = await ajax.post("/api/services/app/Account/SendEmailActivationLink", payload.data as SendEmailActivationLinkInput)
      // console.log('/api/services/app/Account/SendEmailActivationLink rep', rep);
      return rep
    },
    async sendEmailActivationLink(content: ActionContext<AccountState, any>, username: string) {
      // console.log('content',content)
      let rep = await ajax.post(`/api/services/app/Account/ResendEmailActivationLink?username=${username}`)
      // console.log('/api/services/app/Account/SendEmailActivationLink rep', rep);
      return rep
    },
    async sendPasswordResetCodeDispatch(content: ActionContext<AccountState, any>, payload: any) {
      let rep = await ajax.post("/api/services/app/Account/SendPasswordResetCode", payload.data)
      // console.log('/api/services/app/Account/SendPasswordResetCode rep', rep);
      return rep
    },
  }
}
const account = new AccountStore()
export default account
